import { combineReducers } from '@reduxjs/toolkit'

import { referralProcess } from './referralList'
import { referralHashProcess } from './referralHash'

export const referral = combineReducers({
  referralList: referralProcess.reducer,
  referralHash: referralHashProcess.reducer,
})
